<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card>
            <form-wizard 
                title=""
                subtitle=""
                color="#007bff"
            >
                <template slot="step" slot-scope="props">
                    <wizard-step :tab="props.tab"
                    :transition="props.transition"
                    :key="props.tab.title"
                    :index="props.index">
                    </wizard-step>
                </template>

               
                <template slot="footer" slot-scope="props">
                    <div class="wizard-footer-left">
                        <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.prev') }} </wizard-button>
                    </div>
                    <div class="wizard-footer-right">
                        <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.next') }} </wizard-button>
                        <wizard-button v-else @click.native="onComplete(props.isLastStep)" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? $t('customer.wizzard.complete') : $t('customer.wizzard.next')}}</wizard-button>
                    </div>
                </template>
                <tab-content title="Hareket Ekle" icon="ti-list" class="formGroup" :before-change="() => changeStep(0,1)">
                    <Form ref="MovementForms" :loading="loading" :forms="MovementForms" />
                </tab-content>
                <tab-content title="Fotoğraf Ekle" icon="ti-image"  class="formGroup"  :before-change="() => changeStep(1,2)">
                    <Form ref="MovementImageForms" :loading="loading" :forms="MovementImageForms" />
                </tab-content>
                <tab-content title="Ürün Ekle" icon="ti-package"  class="formGroup"  :before-change="() => changeStep(2,3)">
                    <Form ref="MovementProductForms" :loading="loading" :forms="MovementProductForms" />
                </tab-content>
            </form-wizard>
        </b-card>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Multiselect from 'vue-multiselect'
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'

    let breadCrumb = [
        { label: i18n.t('pages.dealer.name'), url: "/Dealer" },
        { label: i18n.t('pages.dealer.serviceForms'), url: '/Dealer/ServiceForms' },
        { label: i18n.t('pages.dealer.addMovement'), url: "" },
    ]
    export default {
        name: 'DealerAdd',
        data: function(){
            return{
                breadCrumb,
                move_id: 0,
                MovementForms: Forms.MovementForms,
                MovementImageForms: Forms.MovementImageForms,
                MovementProductForms: Forms.MovementProductForms
            }
        },
        components:{
            BreadCrumb, Multiselect, Form
        },
        methods:{
             getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            changeStep: async function(prevIndex, nextIndex){
                switch(prevIndex){
                    case 0:
                        return this.$refs.MovementForms.$refs.Form.validate().then( async success =>{
                            if(success){
                                let data = prepareRequestData(this.MovementForms, this.$refs.MovementForms.formData)
                                data.id = this.$route.params.id,
                                await this.$store.dispatch('servicemovements_add', data)
                                if(this.$store.getters.getServiceForm.status == "Success"){
                                    if( this.$store.getters.getServiceForm.data )
                                        this.move_id = this.$store.getters.getServiceForm.data.movement_id
                                    else
                                        this.move_id = 0
                                    return true
                                }else{
                                    return false
                                }
                            }else {
                                return false
                            }
                        })  
                    case 1:
                        return this.$refs.MovementImageForms.$refs.Form.validate().then( async success =>{
                            if(success){
                                let data = prepareRequestData(this.MovementImageForms, this.$refs.MovementImageForms.formData)
                                data.id = this.$store.getters.getServiceForm.data.movement_id
                                if(this.$refs.MovementImageForms.formData.type !== 'noImage'){
                                    await this.$store.dispatch('servicemovementsphoto_add', data)
                                    if(this.$store.getters.getServiceFormPhoto.status == "Success"){
                                        return true
                                    }else{
                                        return false
                                    }
                                }else{
                                    return true
                                }
                               
                            }else {
                                return false
                            }
                        })
                    case 2:
                        return this.$refs.MovementProductForms.$refs.Form.validate().then( async success =>{
                            if(success){
                                let data = prepareRequestData(this.MovementProductForms, this.$refs.MovementProductForms.formData)
                                data.id = this.$store.getters.getServiceForm.data.movement_id,
                                await this.$store.dispatch('servicemovementsproduct_add', data)
                                if(this.$store.getters.getServiceForm.status == "Success"){
                                    this.$router.push('/Dealer/ServiceForms/'+this.$route.params.id+'/Movements')
                                    return true
                                }else{
                                    return false
                                }
                            }else {
                                return false
                            }
                        })
                    default:
                        return false
                }
            }
        }
    }
</script>
<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Dealer/ServiceFormMovementAdd.vue